<template>
    <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <!-- login page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-md-12">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="text-center"><img alt="" src="../assets/images/logo-dark.png" width="150"></div>
                                <div class="card mt-4">
                                    <div class="card-body d-flex justify-content-center align-items-center flex-column" v-if="successModal">
                                        <img width="128" class="mb-5 mt-5" src="../assets/images/checked.png" alt="">
                                        <h5 class="mb-4 text-center">Password has been changed successfully</h5>
                                    </div>
                                    <div class="card-body" v-else>
                                        <div class="text-center text-uppercase">
                                            <h4>Change Password</h4>
                                        </div>
                                        <form class="theme-form" @submit.prevent="handleSubmit">
                                            <div class="form-group">
                                                <label for="email" class="col-form-label">Email <span>*</span></label>
                                                <input type="email" v-model="user.email" id="email" name="email"
                                                     class="form-control"
                                                     :class="{ 'is-invalid': submitted && $v.user.email.$error }"/>
                                                <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                                                    <span v-if="!$v.user.email.required">Email is required</span>
                                                    <span v-if="!$v.user.email.email">Email is invalid</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="password" class="col-form-label">Password <span>*</span></label>
                                                <div class="password-eye" :class="{ 'eye-right': submitted && $v.user.password.$error }">
                                                  <i :class="'fa ' + (showEye ? 'fa-eye' : 'fa-eye-slash')" @click="showEye = !showEye"></i>
                                                  <input :type="showEye ? 'password' : 'text'" v-model="user.password" id="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && $v.user.password.$error }" />
                                                </div>
                                                <div v-if="submitted && $v.user.password.$error" class="invalid-feedback" style="display: flex;flex-direction: column">
                                                    <span v-if="!$v.user.password.required">Password is required</span>
                                                    <span v-if="!$v.user.password.password6Characters && $v.user.password.required">Password must be at least 6 characters</span>
                                                    <span v-if="!$v.user.password.passwordCapitalLetter && $v.user.password.required">Password must have at least one capital letter</span>
                                                    <span v-if="!$v.user.password.passwordNumber && $v.user.password.required">Password must have at least one number</span>
                                                    <span v-if="!$v.user.password.passwordSymbol && $v.user.password.required">Password must have at least one special symbol</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="confirmPassword" class="col-form-label">Confirm Password <span>*</span></label>
                                                <input type="password" v-model="user.confirmPassword" id="confirmPassword" name="confirmPassword" class="form-control" :class="{ 'is-invalid': submitted && $v.user.confirmPassword.$error }" />
                                                <div v-if="submitted && $v.user.confirmPassword.$error" class="invalid-feedback">
                                                    <span v-if="!$v.user.confirmPassword.required">Confirm Password is required</span>
                                                    <span v-else-if="!$v.user.confirmPassword.sameAsPassword">Passwords must match</span>
                                                </div>
                                            </div>
                                            <div class="form-group form-row mt-3 mb-0 loading-wrapper">
                                                <div class="btn-loading" v-if="loading">
                                                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                                </div>
                                                <button class="btn btn-primary btn-block">Reset password</button>
                                            </div>
                                            <hr class="hr-text" data-content="OR">
                                            <div class="form-group form-row mt-3 mb-0 row">
                                                <router-link to="/auth/login" tag="button"
                                                     class="btn btn-secondary btn-block">Login
                                                </router-link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- login page end-->
        </div>
    </div>
    <!-- latest jquery-->
</template>

<script>
  import {required, sameAs, email} from "vuelidate/lib/validators";

  export default {
    name: 'reset-password',
    data() {
      return {
        token: "",
        user: {
          email: "",
          password: "",
          confirmPassword: "",
        },
        submitted: false,
        loading: false,
        successModal: false,
        showEye: true
      }
    },
    validations: {
      user: {
        email: {required, email},
        password: { required,
          password6Characters:(password) => {
            return password.length >= 6
          },
          passwordCapitalLetter: (password) => {
            return /[A-Z]/.test(password)
          },
          passwordNumber: (password) => {
            return /[0-9]/.test(password)
          },
          passwordSymbol: (password) => {
            return /[-!@#$%^&*()_+|~=`{}[\]:";'<>?,./]/.test(password)
          }
        },
        confirmPassword: { required, sameAsPassword: sameAs('password') }
      }
    },
    methods: {
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        let user = {
          "email": this.user.email,
          "newPassword": this.user.password,
          "token": this.token.replace(/\s/g, '+')
        };

        this.loading = true;

        this.$store.dispatch('resetPassword', user).then((val) => {
          this.loading = false;
          if (val.status === 200) {
            this.$router.push('?m=success');
          } else {
            this.$toasted.show("Please try again", {
              theme: 'bubble',
              position: "bottom-right",
              type: 'error',
              duration: 3000
            });
          }
        }).catch((res) => {
          let msg = "";
          if (res.response.data.isError) {
            msg = res.response.data.responseException.exceptionMessage
          } else {
            msg = "Please try again"
          }
          this.$toasted.show(msg, {
            theme: 'bubble',
            position: "bottom-right",
            type: 'error',
            duration: 3000
          });
          this.loading = false;
        })
      },
      checkUrl() {
        this.successModal = !!(this.$route.query.m && this.$route.query.m === "success");
      }
    },
    created() {
      this.checkUrl();
      if (!this.$route.query.token) {
        if (!this.$route.query.m) {
          this.$router.push('/auth/login');
        }
      } else {
        this.token = this.$route.query.token ? this.$route.query.token : ""
      }
    },
    watch: {
      '$route.query': {
        handler() {
          this.checkUrl()
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .page-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
  .authentication-main .auth-innerright {
    min-height: auto;
  }
  .authentication-main {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .password-eye {
    position: relative;

    i {
      position: absolute;
      z-index: 2;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #7a7a7a;
      font-size: 17px;
      cursor: pointer;
    }

    &.eye-right {
      i {
        right: 32px;
      }
    }
  }
</style>
